import { lang } from '../../assets/lang'
const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
const messenger_engagement_plugin = window.xitFlowBuilderData.messenger_engagement_plugin

const actionsFb = [
  { key: 'get-started',  value: lang.action_button_html_actions_get_started },
  { key: 'no match',  value: lang.action_button_html_actions_no_match },
  { key: 'UNSUBSCRIBE_QUICK_BOXER',  value: lang.action_button_html_actions_unsubscribe },
  { key: 'RESUBSCRIBE_QUICK_BOXER',  value: lang.action_button_html_actions_resubscribe },
  { key: 'QUICK_REPLY_EMAIL_REPLY_BOT',  value: lang.action_button_html_actions_email },
  { key: 'QUICK_REPLY_PHONE_REPLY_BOT',  value: lang.action_button_html_actions_phone },
  { key: 'QUICK_REPLY_LOCATION_REPLY_BOT',  value: lang.action_button_html_actions_location },
  { key: 'QUICK_REPLY_BIRTHDAY_REPLY_BOT',  value: lang.action_button_html_actions_birthday },
  { key: 'YES_START_CHAT_WITH_HUMAN',  value: lang.action_button_html_actions_with_human },
  { key: 'YES_START_CHAT_WITH_BOT',  value: lang.action_button_html_actions_with_robot },
]

if (messenger_engagement_plugin) {
  actionsFb.unshift(
    { key: 'messenger_engagement_plugin',  value: lang.action_button_html_actions_messenger_engagement_plugin },
  )
}

const actionsIg = [
  { key: 'STORY_MENTION',  value: lang.action_button_html_actions_story_mention },
  { key: 'no match',  value: lang.action_button_html_actions_no_match },
  { key: 'STORY_PRIVATE_REPLY',  value: lang.action_button_html_actions_story_private_reply },
  { key: 'MESSAGE_UNSEND_PRIVATE_REPLY',  value: lang.action_button_html_actions_message_unsend_private_reply },
]

const actionButtonActionsList = instagram_bot_addon ? actionsIg : actionsFb

const messengerEngagementPluginsList = [
  { key: 'checkbox_plugin', value: lang.action_button_html_messenger_engagement_plugin_checkbox_plugin },
  { key: 'send_to_messenger', value: lang.action_button_html_messenger_engagement_plugin_send_to_messenger },
  { key: 'm_me_link', value: lang.action_button_html_messenger_engagement_plugin_m_me_link },
  { key: 'customer_chat_plugin', value: lang.action_button_html_messenger_engagement_plugin_customer_chat_plugin },
]

const ctaButtonTextsList = [
  { key: 'GET_THIS_IN_MESSENGER', value: 'GET THIS IN MESSENGER' },
  { key: 'RECEIVE_THIS_IN_MESSENGER', value: 'RECEIVE THIS IN MESSENGER' },
  { key: 'SEND_THIS_TO_ME', value: 'SEND THIS TO ME' },
  { key: 'GET_CUSTOMER_ASSISTANCE', value: 'GET CUSTOMER ASSISTANCE' },
  { key: 'GET_CUSTOMER_SERVICE', value: 'GET CUSTOMER SERVICE' },
  { key: 'GET_SUPPORT', value: 'GET SUPPORT' },
  { key: 'LET_US_CHAT', value: 'LET US CHAT' },
  { key: 'SEND_ME_MESSAGES', value: 'SEND ME MESSAGES' },
  { key: 'ALERT_ME_IN_MESSENGER', value: 'ALERT ME IN MESSENGER' },
  { key: 'SEND_ME_UPDATES', value: 'SEND ME UPDATES' },
  { key: 'MESSAGE_ME', value: 'MESSAGE ME' },
  { key: 'LET_ME_KNOW', value: 'LET ME KNOW' },
  { key: 'KEEP_ME_UPDATED', value: 'KEEP ME UPDATED' },
  { key: 'TELL_ME_MORE', value: 'TELL ME MORE' },
  { key: 'SUBSCRIBE_IN_MESSENGER', value: 'SUBSCRIBE IN MESSENGER' },
  { key: 'SUBSCRIBE_TO_UPDATES', value: 'SUBSCRIBE TO UPDATES' },
  { key: 'GET_MESSAGES', value: 'GET MESSAGES' },
  { key: 'SUBSCRIBE', value: 'SUBSCRIBE' },
  { key: 'GET_STARTED_IN_MESSENGER', value: 'GET STARTED IN MESSENGER' },
  { key: 'LEARN_MORE_IN_MESSENGER', value: 'LEARN MORE IN MESSENGER' },
  { key: 'GET_STARTED', value: 'GET STARTED' },
]

export {
  actionButtonActionsList,
  messengerEngagementPluginsList,
  ctaButtonTextsList,
}